import { HttpService } from "@/utils/request";

/**
 * 获取设备列表
 * @param query
 * @returns {*}
 */
export function getDeviceManagementList(query) {
    return HttpService({
        url: "/equipment/list",
        method: "POST",
        data: query
    });
}
/**
 * 保存设备
 * @param query
 * @returns {*}
 */
export function saveDeviceManagementList(query) {
    return HttpService({
        url: "/equipment/save",
        method: "POST",
        data: query
    });
}
/**
 * 保存设备货位
 * @param query
 * @returns {*}
 */
export function saveWarehouseSet(query) {
    return HttpService({
        url: "/equipment/saveEquipmentCargolocations",
        method: "POST",
        data: query
    });
}
/**
 * 获取设备货位信息
 * @param query
 * @returns {*}
 */
export function getWarehouseSetInfo(query) {
    return HttpService({
        url: "/equipment/detailEquipmentCargolocations",
        method: "POST",
        data: query
    });
}
/**
 * 获取设备详情信息
 * @param query
 * @returns {*}
 */
export function getGeviceManagement(query) {
    return HttpService({
        url: "/equipment/detail",
        method: "POST",
        data: query
    });
}
/**
 * 获取设备详情信息
 * @param query
 * @returns {*}
 */
export function deleteGeviceManagement(query) {
    return HttpService({
        url: "/equipment/delete",
        method: "POST",
        data: query
    });
}

// 获取设备种类
export function getDeviceType() {
    return HttpService({
        url:'app/devType',
        method:'GET'
    })
}
